import {CommandActionPayload, CommandFailureActionPayload} from '../../shared/actions/abstract-actions';
import {Product} from '../models/product';
import {LoadCollectionCommand} from '../models/product-commands';
import {createAction, props} from '@ngrx/store';

// helper:
export interface ProductsLoadedSuccessActionPayload<C> extends CommandActionPayload<C> {
    products: Product[];
    totalProductCount: number;
}

// only triggered on page load
// product collection load:
export const load = createAction(
    '[ProductCollection] Load',
    props<CommandActionPayload<LoadCollectionCommand>>()
);

export const loadSuccess = createAction(
    '[ProductCollection] LoadSuccess',
    props<ProductsLoadedSuccessActionPayload<LoadCollectionCommand>>()
);

export const loadFailure = createAction(
    '[ProductCollection] LoadFailure',
    props<CommandFailureActionPayload<LoadCollectionCommand>>()
);

// pagination actions
// product collection add:
export const add = createAction(
    '[ProductCollection] Add',
    props<CommandActionPayload<{}>>()
);

export const addSuccess = createAction(
    '[ProductCollection] AddSuccess',
    props<ProductsLoadedSuccessActionPayload<{}>>()
);

export const addFailure = createAction(
    '[ProductCollection] AddFailure',
    props<CommandFailureActionPayload<{}>>()
);
